export const typeHoursLabel: { [key: string]: any } = {
    work: 'Lavoro Feriale',
    work_sunday: 'Lavoro Domenicale',
    work_festive: 'Lavoro Festivo',
    hoursOfLeave: 'Permesso',
    vacationHours: 'Ferie',
    sick: 'Malattia',
    festive: 'Festivo',
    extraHours: 'Banca',
}

export const typeHoursWorkInitArray = [
    {name: 'work', label: typeHoursLabel.work},
    {name: 'work_sunday', label: typeHoursLabel.work_sunday},
    {name: 'work_festive', label: typeHoursLabel.work_festive},
]
export const typeHoursNotWorkInitArray = [
    {name: 'hoursOfLeave', label: typeHoursLabel.hoursOfLeave},
    {name: 'vacationHours', label: typeHoursLabel.vacationHours},
    {name: 'sick', label: typeHoursLabel.sick},
    {name: 'festive', label: typeHoursLabel.festive},
    {name: 'extraHours', label: typeHoursLabel.extraHours, timeBank: true},
]
export const typologyHoursName = {
    work: 'work',
    notWork: 'notWork',
}
export const typeHoursInitArray: any[]= [
    ...typeHoursWorkInitArray.map(ele => ({
        ...ele,
        typology: typologyHoursName.work
    })),
    ...typeHoursNotWorkInitArray.map(ele => ({
        ...ele,
        typology: typologyHoursName.notWork

    }))

]
export const typeHourWork = []
export const typeHours = {
    work: 'work',
    work_sunday: 'work_sunday',
    work_festive: 'work_festive',
    hoursOfLeave: 'hoursOfLeave',
    vacationHours: 'vacationHours',
    sick: 'sick',
    extraHours: 'extraHours',
    festive: 'festive'
}
export const typeHoursArray = Object.values(typeHours)



